
import { computed, defineComponent, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
export default defineComponent({
  name: '',
  setup() {
    const route = useRoute()
    const store = useStore()
    const data = reactive({
      activityInfo: computed(() => store.state.activityInfo),
    })

    return {
      ...toRefs(data),
      route,
    }
  },
})
